import React from 'react';

function PromptButtons({ promptButtonsData, onButtonClick }) {
  return (
    <div className="prompt-buttons">
      {promptButtonsData.map(buttonData => (
        <button 
          key={buttonData.label}
          className="size-button"
          onClick={() => onButtonClick(buttonData.prompt)}
        >
          {buttonData.label}
        </button>
      ))}
    </div>
  );
}

export default PromptButtons;
